export default __webpack_public_path__ + "static/media/Greatshield of the Fallen Empire.9ae155ef.jpg";